/**
 * If we request a `latest` dimension, but only have `stable` in our map then we use it.
 * If we request a `stable` dimension, but only have `latest` an error will be thrown due to the variant order.
 */
export var VARIANT_ORDER = ['latest', 'stable'];
export var MODULE_NAMESPACE_ALIAS = 'app-switcher';